import { useState } from "react";
import { motion } from "framer-motion";
import { Play } from "lucide-react";

export default function Constat() {
  const [playing, setPlaying] = useState(false);

  return (
    <section id="constat" data-testid="constat-section" className="py-24 md:py-32 border-b border-white/10">
      <div className="max-w-7xl mx-auto px-6 md:px-12 text-center">
        <motion.h2
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8 }}
          className="font-display text-4xl sm:text-5xl lg:text-6xl leading-[1.08] text-[#F5F5F0]"
        >
          Les <span className="italic text-[#FF6B00]">rapports de force</span> changent.
        </motion.h2>

        <motion.div
          initial={{ opacity: 0, scaleX: 0 }}
          whileInView={{ opacity: 1, scaleX: 1 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="w-[60px] h-px bg-[#FF6B00] mx-auto my-6 md:my-8"
          aria-hidden="true"
        />

        <motion.h2
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, delay: 0.15 }}
          className="font-display text-4xl sm:text-5xl lg:text-6xl leading-[1.08] text-[#F5F5F0]"
        >
          La technologie devient un enjeu de <span className="italic text-[#FF6B00]">puissance</span>.
        </motion.h2>

        <motion.div
          initial={{ opacity: 0, scaleX: 0 }}
          whileInView={{ opacity: 1, scaleX: 1 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6, delay: 0.35 }}
          className="w-[60px] h-px bg-[#FF6B00] mx-auto my-6 md:my-8"
          aria-hidden="true"
        />

        <motion.h2
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, delay: 0.3 }}
          className="font-display text-4xl sm:text-5xl lg:text-6xl leading-[1.08] text-[#F5F5F0]"
        >
          Des entreprises en <span className="italic text-[#FF6B00]">profitent</span>.
        </motion.h2>

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8 }}
          className="mt-8 md:mt-10"
        >
          <p className="font-mono text-[11px] tracking-[0.3em] uppercase text-[#A3B8B0]" data-testid="video-label">
            Regarder l'introduction
          </p>
          <div
            className="max-w-[1000px] mx-auto border border-white/10 bg-white/[0.02] p-2 rounded-sm mt-5"
            data-testid="intro-video"
          >
            <div className="relative w-full" style={{ paddingTop: "56.25%" }}>
              {playing ? (
                <iframe
                  src="https://www.youtube-nocookie.com/embed/Gm9dttcW_k8?autoplay=1"
                  title="Introduction MULTIPOLAR"
                  className="absolute inset-0 w-full h-full"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  referrerPolicy="strict-origin-when-cross-origin"
                  allowFullScreen
                />
              ) : (
                <button
                  type="button"
                  onClick={() => setPlaying(true)}
                  data-testid="intro-video-play"
                  aria-label="Lire la vidéo d'introduction"
                  className="absolute inset-0 w-full h-full group cursor-pointer"
                >
                  <img
                    src="https://i.ytimg.com/vi/Gm9dttcW_k8/maxresdefault.jpg"
                    alt="Miniature de la vidéo d'introduction MULTIPOLAR"
                    className="absolute inset-0 w-full h-full object-cover"
                    loading="lazy"
                  />
                  <span className="absolute inset-0 bg-[#06120E]/20 group-hover:bg-[#06120E]/10 transition-colors duration-300" aria-hidden="true" />
                  <span
                    className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-16 h-16 md:w-20 md:h-20 rounded-full border border-white/40 bg-[#06120E]/50 flex items-center justify-center transition-[border-color,background-color,transform] duration-300 group-hover:border-[#FF6B00] group-hover:scale-105"
                    aria-hidden="true"
                  >
                    <Play size={26} className="text-[#F5F5F0] group-hover:text-[#FF6B00] transition-colors duration-300 ml-1" fill="currentColor" />
                  </span>
                </button>
              )}
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
